module.exports = __webpack_public_path__ + "static/media/abstraction_teaser_fig.634d1890.png";